module.exports = __webpack_public_path__ + "img/review.967f480b.svg";